<template lang='slm'>
  form.text-left @submit.prevent='formSubmit'
    template v-if='item'
      button.d-none
      .form-group
        label Картинка
        .d-block.text-center
          img.preview :src='"/api/file/" + item.coverId + "?original"'
          small.d-block.mt-1 350x350
        admin-file-uploader v-model='item.coverId'
      .form-group
        label Название
        input.form-control type='text' name='title' v-model='item.title' v-validate='"required"'
        small.text-danger v-show="errors.has('title')" {{ errors.first('title') }}
      .form-group
        label Исполнитель
        input.form-control type='text' name='artist' v-model='item.artist' v-validate='"required"'
        small.text-danger v-show="errors.has('artist')" {{ errors.first('artist') }}
      .form-group
        label Год
        input.form-control type='number' name='year' v-model.number='item.year' v-validate='"required"'
        small.text-danger v-show="errors.has('year')" {{ errors.first('year') }}
</template>

<!--
IDEA Можно этот modal сделать xl и прямо в него вставить таблицу с песнями с возможностью закинуть кучу файлов,
которые по очереди будут грузится, с них поттянутся имена и прямо внутри этой таблицы можно менять песни местами, удалять и т.д.
-->

<script>
import AdminFileUploader from '@/components/AdminFileUploader';

export default {
  name: 'AdminAlbumModalContent',
  components: { AdminFileUploader },
  data() {
    return {
      item: null,
    };
  },
  methods: {
    formSubmit() {
      this.$parent.confirm();
    },
    beforeShow(item) {
      this.item = this.$_removeImmutabitity(item);
      // eslint-disable-next-line no-underscore-dangle
      delete this.item.__typename;
    },
  },
  computed: {
    modalContentData() {
      return this.item;
    },
  },
  mounted() {
    this.$on('beforeShow', this.beforeShow);
  },
};
</script>
